// extracted by mini-css-extract-plugin
export default {"container":"style_container__1snYH","innerBox":"style_innerBox__PCU4f","imageBox":"style_imageBox__AGxRW","description":"style_description__Lrhme","link":"style_link__Fy-aD"};